module.exports = __webpack_public_path__ + "static/media/eesha_kurode.9ac05973.jpg";